import { ANYWHERE_PLACE_ID } from 'constants/search'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import { ResultsFilteredByDestination } from './ResultsFilteredByDestination'
import { ResultsFilteredByHolidayType } from './ResultsFilteredByHolidayType'
import { ResultsFilteredByHolidayTypeAndDestination } from './ResultsFilteredByHolidayTypeAndDestination'
import { UnfilteredResults } from './UnfilteredResults'
import LayoutContainer from 'components/Common/LayoutContainer'
import ImageHero from 'components/Common/ImageHero'
import cn from 'clsx'

const HeroImage = styled(ImageHero)`
  background-color: ${props => props.theme.palette.brand.primary.normal};
  max-height: ${rem(400)};
`

const HeroDefault = styled.div`
  background-color: ${props => props.theme.palette.brand.primary.normal};
  max-height: ${rem(400)};
`

const HeadingSection = styled.div`
  padding-top: ${rem(100)};
  padding-bottom: ${rem(100)};
`

interface Props {
  destinationId: string;
  destination: string;
  holidayType: string;
  validHolidayType: boolean;
}

export function HolidayTypeLandingPageHero({ destinationId, destination, holidayType, validHolidayType }: Props) {
  function getImageId() {
    switch (holidayType) {
      case 'Family friendly':
        return 'holidayType.familyFriendly'
      case 'Honeymoon':
      case 'Adults only':
      case 'Romantic':
        return 'holidayType.couples'
      default:
        return undefined
    }
  }
  const imageId = getImageId()
  const hasImage = imageId !== undefined
  const anywhereDestinationId = destinationId === ANYWHERE_PLACE_ID
  const validDestination = destinationId && !anywhereDestinationId

  const showResultsFilteredByHolidayTypeAndDestination = validHolidayType && validDestination
  const showResultsFilteredByHolidayType = validHolidayType && !validDestination
  const showResultsFilteredByDestination = !validHolidayType && validDestination
  const showUnfilteredResults = !validHolidayType && !validDestination

  function FilteredResultsHeading() {
    return (
      <HeadingSection className={cn({ 'has-image': hasImage })}>
        {showResultsFilteredByHolidayTypeAndDestination &&
          <ResultsFilteredByHolidayTypeAndDestination
            holidayType={holidayType}
            destination={destination}
            hasImage={hasImage}
          />
      }
        {showResultsFilteredByHolidayType && <ResultsFilteredByHolidayType holidayType={holidayType} hasImage={hasImage} />}
        {showResultsFilteredByDestination && <ResultsFilteredByDestination destination={destination} hasImage={hasImage} />}
        {showUnfilteredResults && <UnfilteredResults />}
      </HeadingSection>
    )
  }

  return (
    <>
      {hasImage &&
        <HeroImage
          id={imageId}
          brightness={-30}
          aria-hidden="true"
          gravity="auto"
          color="pink"
        >
          <LayoutContainer >
            <FilteredResultsHeading />
          </LayoutContainer>
        </HeroImage>
      }
      {!hasImage &&
        <HeroDefault>
          <LayoutContainer>
            <FilteredResultsHeading />
          </LayoutContainer>
        </HeroDefault>
      }
    </>
  )
}
